import axios from 'axios';

/**
 * @deprecated please use callAPI
 */
export async function Get(url) {
  try {
    let result = await axios.get(url);
    return result.data;
  } catch (error) {
    return catchError(error.response);
  }
}

/**
 * @deprecated please use callAPI
 */
export async function Post(url, data) {
  try {
    let result = await axios.post(url, data);
    return result.data;
  } catch (error) {
    return catchError(error.response);
  }
}

function catchError(response) {
  return {
    message: response.statusText,
    responseCode: response.status,
    data: [],
  };
}
